/* global FNGPlayer */
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useAuth } from 'index/AuthProvider';
import { getPlayerJs, PLAYER_REFERENCE_GLOBAL } from 'helpers/PlayerHelper';
import { VIDEO_TYPE_WATCH, VIDEO_TYPE_TRAILER, VIDEO_TYPE_LIVE } from 'helpers/ContentHelper';
import scriptjs from 'scriptjs';
import getVideoConfig from './VideoConfig';
import Style from './VideoPlayer.module.scss';

const playerId = `video-player-${PLAYER_REFERENCE_GLOBAL}`;

// we can pass in live or not live
// create overlay hook useVideoOverlay
// everything in watch context in video player controller / helper
// have the this player in the new watch page
// look into how we deal with the restart stuff - hash? continueous?
// usePlayerContext - custom hook that takes in type of player, that will generate whole config
// WatchContext and liveContext for player callbacks, see best way to combine into one, have a default?
// pass a type, Overlay in VideoPlayer, useVideoOverlay will return a type instead?
const PlayerController = ({ type, video, ...rest }) => {
  const { accessToken, account, anonymousAccount } = useAuth();
  const config = useMemo(
    () => getVideoConfig({ accessToken, account, anonymousAccount, video, type, rest }),
    [video, accessToken, account, anonymousAccount],
  );
  return <Player type={type} config={config} />;
  // get player state
  // go over all the overlays, see what is not needed in storybook. (do this first)
  // seperate out in a ticket, modernize overlays
  // email capture overlay, preview pass 5 and 60 min, upsell banner,
  // have data test attribute, useful for debugging. ex: data-test={`${overlayType}`}
  // return (
  //   <VideoOverlay type={'upsell-banner'}>
  //     <Player type={type} config={config} />
  //   </VideoOverlay>
  // );
};

PlayerController.propTypes = {
  video: PropTypes.shape({}),
  type: PropTypes.string,
};

const Player = ({ config, type }) => {
  useEffect(() => {
    const playerJs = getPlayerJs();
    scriptjs(playerJs, 'player');
    scriptjs.ready('player', () => {
      const player = FNGPlayer.default;
      player.configPlayer(() => {
        player.load(config, player => {
          if (!window.player) window.player = {};
          window.player[PLAYER_REFERENCE_GLOBAL] = player;
        });
      });
    });
  }, [config]);

  return (
    <div
      className={classNames({
        [Style.videoPlayerContainer]: true,
        [Style.videoTrailer]: type === VIDEO_TYPE_TRAILER,
        [Style.videoWatch]: type === VIDEO_TYPE_WATCH,
        [Style.videoLive]: type === VIDEO_TYPE_LIVE,
      })}
      key={playerId}
    >
      <div id={playerId} />
    </div>
  );
};

Player.propTypes = {
  config: PropTypes.shape({}),
  type: PropTypes.string,
};

export default PlayerController;
